import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { updateCity } from "../../../../../services/Admin/ShippingCategoriesApi";
import { getShippingCategories } from "../../../../../services/Admin/ShippingCategoriesApi";

const EditCityDialog = ({ open, onClose, onSuccess, city, governorates = [], categoryId }) => {
  const [loading, setLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [nameAr, setNameAr] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [status, setStatus] = useState(true);
  const [shippingCategoryId, setShippingCategoryId] = useState("");
  const [governorateId, setGovernorateId] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setNameAr(city?.name_ar || "");
      setNameEn(city?.name_en || "");
      setStatus(city?.status === 1 || city?.status === true);
      setShippingCategoryId(city?.shipping_category_id ?? categoryId ?? "");
      setGovernorateId(city?.governorate_id ?? "");
      fetchCategories();
      setError("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, city, categoryId]);

  const fetchCategories = async () => {
    setCategoriesLoading(true);
    try {
      const res = await getShippingCategories();
      const data = res?.success ? res.data : res;
      const all = [];
      if (Array.isArray(data)) {
        data.forEach((g) => {
          if (g.categories) all.push(...g.categories);
        });
      }
      setCategories(all);
    } catch (err) {
      console.error(err);
    } finally {
      setCategoriesLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError("");
    if (!city?.id) return;
    if (!nameAr.trim() && !nameEn.trim()) {
      setError("يرجى إدخال اسم المدينة");
      return;
    }
    const payload = {
      name_ar: nameAr.trim(),
      name_en: nameEn.trim(),
      status: !!status,
      shipping_category_id: shippingCategoryId ? Number(shippingCategoryId) : null,
      governorate_id: governorateId ? Number(governorateId) : null,
    };
    setLoading(true);
    try {
      const res = await updateCity(city.id, payload);
      if (res?.success) {
        onSuccess?.();
      } else {
        setError(res?.message || "فشل تعديل المدينة");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء التعديل");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل المدينة</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="الاسم بالعربية" value={nameAr} onChange={(e) => setNameAr(e.target.value)} fullWidth />
          <TextField label="الاسم بالإنجليزية" value={nameEn} onChange={(e) => setNameEn(e.target.value)} fullWidth />

          <FormControl fullWidth size="small">
            <InputLabel>المحافظة</InputLabel>
            <Select value={governorateId} label="المحافظة" onChange={(e) => setGovernorateId(e.target.value)}>
              <MenuItem value="">بدون</MenuItem>
              {governorates.map((g) => (
                <MenuItem key={g.id} value={g.id}>
                  {g.name_ar || g.name_en}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>شريحة الشحن</InputLabel>
            <Select
              value={shippingCategoryId}
              label="شريحة الشحن"
              onChange={(e) => setShippingCategoryId(e.target.value)}
              disabled={categoriesLoading || !!categoryId}
            >
              <MenuItem value="">بدون</MenuItem>
              {categories.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.name} {c.cost ? `- ${Number(c.cost).toFixed(2)}` : ""}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControlLabel
            control={<Switch checked={status} onChange={(e) => setStatus(e.target.checked)} />}
            label={status ? "مفعّل" : "معطّل"}
          />

          {error && <Typography color="error" variant="body2">{error}</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCityDialog;
